// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1eA2L","bigColWidth":"Table_bigColWidth__32dNJ","biggerColWidth":"Table_biggerColWidth__2sDrV","row":"Table_row__B6DHU","col":"Table_col__16vh_"};